import React, { Suspense, lazy, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate, useLocation, Outlet, useParams, HashRouter } from "react-router-dom";
import { HOSTNAME } from "../config/constants";
import config from "../config/config.json";

import Navbar from "../layout/Navbar";
import Sidebar from "../layout/Sidebar";
import SidebarOpen from "../layout/SidebarOpen";
import ComingSoon from "../pages/ComingSoon";
import NotFound from "../pages/NotFound";
import Login from "../pages/Login";
// import Settings from "../pages/Settings";
import { setTheme } from "../redux/actions/styles";
import "../config/firebaseConfig";
import Menu from "../pages/Menu";
import Cart from "../pages/Cart";
import { getConfig, getData } from "../redux/actions/menu";
import AddItems from "../pages/AddItems";

import EditItems from "../pages/EditItems";
import Footer from "../layout/Footer";
import ScrollToTop from "../layout/ScrollToTop";
import Configure from "../pages/Settings/Configure";
import BottomTabs from "../layout/BottomTabs";
import Accounts from "../pages/Settings/Configure/Accounts";
import SplashScreen from "../layout/SplashScreen";
import { getAuth, getIdTokenResult, onAuthStateChanged } from "firebase/auth";
import InitialSetup from "../pages/InitialSetup";
import InitialAuth from "../pages/InitialAuth";
import { logOut, signIn } from "../redux/actions/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebaseConfig";
import Outlets from "../pages/Settings/Outlets";
import OutletPage from "../pages/Settings/Outlets/OutletPage";
import Landing from "../pages/Landing";
import PrivateRoute from "./PrivateRoute";
// import OutletDetails from "../pages/Settings/OutletDetails";
// import OutletTables from "../pages/Settings/OutletTables";
// import AddOutlet from "../pages/Settings/AddOutlet";
// import OrdersRestaurant from "../pages/OrdersRestaurant";
// import EditFilter from "../pages/EditItems/EditFilter";
// import EditSection from "../pages/EditItems/EditSection";
// import EditMenu from "../pages/EditItems/EditMenu";
// import AddFilter from "../pages/AddItems/tabs/AddFilter";
// import AddFood from "../pages/AddItems/tabs/AddFood";
// import AddSection from "../pages/AddItems/tabs/AddSection";
// import CompanyInfo from "../pages/Settings/Configure/CompanyInfo";
// import CompanyTheme from "../pages/Settings/Configure/CompanyTheme";

import More from "../pages/More";
import MenuSection from "../pages/MenuSection";
import Orders from "../pages/Orders";
import PrivateRouteAdmin from "./PrivateRouteAdmin";
import ManageUsers from "../pages/Settings/ManageUsers";

const Settings = lazy(() => import("../pages/Settings"));
const OutletDetails = lazy(() => import("../pages/Settings/OutletDetails"));
const OutletTables = lazy(() => import("../pages/Settings/OutletTables"));
const AddOutlet = lazy(() => import("../pages/Settings/AddOutlet"));
const OrdersRestaurant = lazy(() => import("../pages/OrdersRestaurant"));

const EditFilter = lazy(() => import("../pages/EditItems/EditFilter"));
const EditSection = lazy(() => import("../pages/EditItems/EditSection"));
const EditMenu = lazy(() => import("../pages/EditItems/EditMenu"));
const AddFilter = lazy(() => import("../pages/AddItems/tabs/AddFilter"));
const AddFood = lazy(() => import("../pages/AddItems/tabs/AddFood"));
const AddSection = lazy(() => import("../pages/AddItems/tabs/AddSection"));
const CompanyInfo = lazy(() => import("../pages/Settings/Configure/CompanyInfo"));
const CompanyTheme = lazy(() => import("../pages/Settings/Configure/CompanyTheme"));

const { DESKTOP_APP } = config;

const AppRouter = !DESKTOP_APP ? HashRouter : BrowserRouter;

const Router = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, isAuthenticatedAdmin } = useSelector((state) => state.auth);
  const { restaurantConfig } = useSelector((state) => state.config);
  const { sectionData } = useSelector((state) => state.menu);

  const [configLoading, setconfigLoading] = useState(true);

  useEffect(() => {
    async function getConfigData() {
      await dispatch(getConfig());
      setconfigLoading(false);
    }

    getConfigData();
  }, []);

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const idToken = await user.getIdToken(true);

          const userAccountsRef = doc(db, "userAccounts", HOSTNAME);
          const userIdRef = doc(userAccountsRef, "accounts", user.email);

          const accounDocSnapshot = await getDoc(userIdRef);

          if (accounDocSnapshot.exists()) {
            const userData = accounDocSnapshot.data();

            dispatch(
              signIn({
                user,
                userData,
              })
            );
          } else {
            const docRef = doc(db, "clients", user.email);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
              const userData = docSnap.data();

              dispatch(
                signIn({
                  user,
                  userData,
                })
              );
              console.log("User signed in");
            } else {
              dispatch(logOut());
            }
          }
        } catch (error) {
          // Handle errors here
          console.log(error);
          dispatch(logOut());
        }
      } else {
        // The user is not signed in
        dispatch(logOut());
        console.log("User not signed in");
      }
    });

    return () => {
      // Unsubscribe the listener when the component unmounts
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("theme");

    if (theme) {
      document.body.classList.add(theme);
      dispatch(setTheme(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (configLoading) {
    return <SplashScreen />;
  }

  if (!restaurantConfig) {
    return (
      <AppRouter>
        <Routes>
          <Route exact path="/" element={<InitialAuth />} />
          <Route exact path="/initial-setup" element={<InitialSetup />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </AppRouter>
    );
  }

  return (
    <AppRouter>
      <Routes>
        <Route exact path="/" element={<MainLayout />}>
          <Route exact path="/" element={<Navigate replace to="/outlets" />} />
          <Route exact path="/initial-setup" element={<Navigate replace to="/outlets" />} />

          <Route exact path="/outlets" element={<Landing />} />
          <Route exact path="/:outlet" element={<Menu />} />
          <Route exact path="/:outlet/:table" element={<Menu />} />
          <Route exact path="/:outlet/section/:section" element={<Menu />} />
          <Route exact path="/:outlet/:table/section/:section" element={<Menu />} />

          <Route exact path="/reservations" element={<ComingSoon />} />
          <Route exact path="/cart/:outlet" element={<Cart />} />
          <Route exact path="/your-orders/:outlet/:table" element={<Orders />} />
          <Route exact path="/your-orders/:outlet" element={<Orders />} />
          <Route exact path="/cart/:outlet/:table" element={<Cart />} />
          <Route exact path="/more/:outlet/" element={<More />} />
          <Route exact path="/more/:outlet/:table" element={<More />} />

          <Route
            exact
            path="/orders"
            element={
              <Suspense fallback={<SplashScreen />}>
                <PrivateRoute />
              </Suspense>
            }
          >
            <Route exact path=":orderType/:outlet" element={<OrdersRestaurant />} />
            <Route exact path=":orderType/:outlet/:table" element={<OrdersRestaurant />} />
          </Route>

          <Route
            exact
            path="/manage"
            element={
              <Suspense fallback={<SplashScreen />}>
                <PrivateRoute />
              </Suspense>
            }
          >
            <Route exact path="" element={<Settings />} />
            <Route exact path=":outlet" element={<Settings />} />
            <Route exact path=":outlet/:table" element={<Settings />} />

            <Route exact path=":outlet/outlet-details" element={<OutletDetails />} />
            <Route exact path=":outlet/outlet-tables" element={<OutletTables />} />

            {/* <Route exact path="config" element={<Configure />} /> */}
            {/* <Route exact path="outlets" element={<Outlets />} /> */}
            {/* <Route exact path="outlets/:outlet" element={<OutletPage />} /> */}

            <Route exact path=":outlet/add" element={<AddItems />}>
              <Route path="filter" element={<AddFilter />} />
              <Route path="food" element={<AddFood />} />
              <Route path="section" element={<AddSection />} />
            </Route>
            <Route exact path=":outlet/:table/add" element={<AddItems />}>
              <Route path="filter" element={<AddFilter />} />
              <Route path="food" element={<AddFood />} />
              <Route path="section" element={<AddSection />} />
            </Route>
            <Route exact path=":outlet/edit" element={<EditItems />}>
              <Route exact path="filter" element={<EditFilter />} />
              <Route exact path="section" element={<EditSection />} />
              <Route exact path="food" element={<EditMenu />} />
            </Route>
            <Route exact path=":outlet/:table/edit" element={<EditItems />}>
              <Route exact path="filter" element={<EditFilter />} />
              <Route exact path="section" element={<EditSection />} />
              <Route exact path="food" element={<EditMenu />} />
            </Route>
          </Route>

          <Route
            exact
            path="/admin"
            element={
              <Suspense fallback={<SplashScreen />}>
                <PrivateRouteAdmin />
              </Suspense>
            }
          >
            <Route exact path="config/company-info/" element={<CompanyInfo />} />
            <Route exact path="config/company-theme/" element={<CompanyTheme />} />
            <Route exact path="config/accounts/" element={<Accounts />} />
            <Route exact path="config/add-outlet/" element={<AddOutlet />} />
            <Route exact path="config/manage-users/" element={<ManageUsers />} />

            <Route exact path="config/company-info/:outlet" element={<CompanyInfo />} />
            <Route exact path="config/company-theme/:outlet" element={<CompanyTheme />} />
            <Route exact path="config/accounts/:outlet" element={<Accounts />} />
            <Route exact path="config/add-outlet/:outlet" element={<AddOutlet />} />
            <Route exact path="config/manage-users/:outlet" element={<ManageUsers />} />

            <Route exact path="config/company-info/:outlet/:table" element={<CompanyInfo />} />
            <Route exact path="config/company-theme/:outlet/:table" element={<CompanyTheme />} />
            <Route exact path="config/accounts/:outlet/:table" element={<Accounts />} />
            <Route exact path="config/add-outlet/:outlet/:table" element={<AddOutlet />} />
            <Route exact path="config/manage-users/:outlet/:table" element={<ManageUsers />} />
          </Route>

          <Route exact path="/coming-soon" element={<ComingSoon />} />
        </Route>

        <Route exact path="/login" element={<Login />} />
        <Route path="*" element={<Navigate replace to="/outlets" />} />
      </Routes>
    </AppRouter>
  );
};

const MainLayout = () => {
  const dispatch = useDispatch();

  const { sidebarActive } = useSelector((state) => state.styles);
  const { sectionData } = useSelector((state) => state.menu);

  const { outlet } = useParams();

  useEffect(() => {
    async function getMenuData() {
      await dispatch(getData(outlet));
    }
    getMenuData();
  }, [outlet]);

  if (sectionData === null) {
    return <SplashScreen />;
  }

  return (
    <>
      <Navbar />
      <Sidebar />
      <SidebarOpen />
      <ScrollToTop />
      <div className={`main ${sidebarActive ? "sidebar-active" : ""}`}>
        <Outlet />
        <Footer />
      </div>
      <BottomTabs />
    </>
  );
};

export default Router;
